export default __webpack_public_path__ + "static/media/beach-logo.1d9af7d0.png";